import type {MouseEvent, MouseEventHandler, ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './media-control-buttons.module.scss';
import {PlayPauseButton} from './components/play-pause-button';

interface MediaControlButtonsProps {
  isPlaying: boolean;
  onPause(e: MouseEvent): void;
  onPlay(e: MouseEvent): void;
  onStop: MouseEventHandler;
  iconSize?: IconSize;

  onSkipForward?(): void;

  showSkipForwardButton?: boolean;
  className?: string;
  isMobileView?: boolean;

  currentTime?: number;
  totalDuration?: number;
}

export function MediaControlButtons({
  isMobileView = false,
  className = '',
  iconSize = IconSize.SIZE_ICON_20,
  onSkipForward = (): void => {},
  showSkipForwardButton = false,
  ...props
}: MediaControlButtonsProps): ReactElement<any> {
  if (isMobileView) {
    return (
      <div className={`${className} ${styles.mediaControlsMobile}`}>
        <PlayPauseButton
          isPlaying={props.isPlaying}
          onPlay={(e): void => {
            props.onPlay(e);
          }}
          onPause={(e): void => {
            props.onPause(e);
          }}
          iconSize={iconSize}
          iconShape={IconShape.CIRCLE}
          iconType={IconType.SHADOW}
          currentTime={props.currentTime}
          totalDuration={props.totalDuration}
        />

        {showSkipForwardButton ? (
          <Icon onClick={onSkipForward} icon="icon-skip-back" ariaLabel={window.i18next.t('pmwjs_next_page')} size={iconSize} type={IconType.SHADOW} shape={IconShape.CIRCLE} />
        ) : null}
      </div>
    );
  }
  return (
    <div className={`${className} ${styles.mediaControls}`}>
      <Icon icon="icon-skip-back" onClick={props.onStop} size={iconSize} type={IconType.GHOST} shape={IconShape.SQUARE} />
      <PlayPauseButton
        isPlaying={props.isPlaying}
        onPlay={(e): void => {
          props.onPlay(e);
        }}
        onPause={(e): void => {
          props.onPause(e);
        }}
        iconSize={iconSize}
      />
      {showSkipForwardButton ? (
        <Icon onClick={onSkipForward} icon="icon-skip-back" ariaLabel={window.i18next.t('pmwjs_next_page')} size={iconSize} type={IconType.GHOST} shape={IconShape.SQUARE} />
      ) : null}
    </div>
  );
}
